export enum BookingQueryKeys {
  GetBooking = 'GetBooking',
  GetUserBookings = 'GetUserBookings',
  SearchBookings = 'SearchBookings',
  GetRemainingBookingsCheck = 'GetRemainingBookingsCheck',
  GetOneBookingForUser = 'GetOneBookingForUser'
}
